function get_unit(key, metric_obj, team_name, metric){
    if(key === 'distance' || key === 'distance_no_zones'){
        if (
            team_name == "Brown University Womens Lacrosse" || 
            team_name == "Kennesaw State Women's Lacrosse" ||
            team_name == "University of Washington WBBall" ||
            team_name == "Pittsburgh Steelers" || 
            team_name == "Harvard University MLAX"
        ) return "yds";
        return metric ? 'km' : 'mi';
    }else if(key === 'sprint_distance' || key === 'high_speed_running' || key === 'z4_z6_distance' || key === 'z6_distance' || key === 'z5_distance' || key === 'hmld'){
        if (
            team_name == "UTSA Football" ||
            team_name == "Tampa Bay Sun" ||
            team_name == "Lexington SC MSoccer"
        ) return "m";
        if (team_name == "Mercer University Women’s Lacrosse") return "mi";
        return metric ? 'm' : 'yds';
    }else if(key === 'distance_per_minute' || key === 'hmld_per_minute'){
        if (team_name == "Mercer University Women’s Lacrosse") return "mi/min";
        if (team_name == "Lexington SC MSoccer") return "m/min";
        return metric ? 'm/min' : 'yds/min';
    }else if(key === 'top_speed'){
        if (team_name == "UMass Lowell Field Hockey") {
            return "mph"
        }
        if (team_name == "Tampa Bay Sun") {
            return 'kph'
        }
        return metric ? 'kph' : 'mph';
    }else if(key === 'accel_decel' || key === 'accel' || key === 'decel' || key === 'accel_max' || key === 'decel_max'){
        if (team_name == "Mississippi Football" || team_name == "Brown University Womens Lacrosse"){
            return "yds/s/s"
        }
        if (team_name == "Mercer University Women’s Lacrosse") return "mi/s/s";
        return metric ? 'm/s/s' : 'm/s/s';
    } else {
        return metric_obj ? metric ? metric_obj.metric_unit : metric_obj.imperial_unit : undefined;
    }
}

function get_dist_unit(team_name, is_metric_unit){
    if (is_metric_unit){
        if (team_name == "UVA WSOC"){
            return 'm'
        } else {
            return 'km'
        }
    } else {
        if ([
            "Georgia Tech Football", 
            'Garden City HS Football', 
            "Mississippi Football", 
            "Illinois Football", 
            "Santa Fe HS Football", 
            "Harvard University WLAX",
            "Brown University Women's Soccer",
            "Archbishop Mitty MSOC",
            "Brown University Womens Lacrosse",
            "Kennesaw State Women's Lacrosse",
            "University of Washington WBBall",
            "Pittsburgh Steelers",
            "Harvard University MLAX"
        ].includes(team_name)){
            return 'yds'
        } else if (team_name == "UTSA Football" || team_name == "Kennesaw State Women's Soccer" || 
            team_name == "Lexington SC MSoccer"
        ){
            return "m"
        } else if (team_name == "Tampa Bay Sun"){
            return "km"
        } else {
            return 'mi'
        }
    }
}

function convertToShortForm(number) {
    if (number < 1000) {
      return number.toString(); // Return the number as it is
    } else {
      const units = ["k", "M", "B", "T"]; // Add more suffixes if needed
      const suffixIndex = Math.floor(Math.log10(number) / 3); // Calculate the appropriate suffix index
      const shortNumber = (number / Math.pow(1000, suffixIndex)).toFixed(1); // Calculate the shortened number
      return shortNumber + units[suffixIndex - 1]; // Append the suffix to the shortened number
    }
  }

  export {get_unit, get_dist_unit, convertToShortForm};